<template>
    <div v-if="dataSource && dataSourceType === 'NPADocument'"
        :key="document.id"
        class="p-relative"
    >

        <Toolbar 
            :menu="dataSource.Data.Menu" 
            v-on:toolbar-button-click="onToolbarClick"  
        />

        <DocumentPanel :document-info="dataSource.Data.Object" />
        <div class="d-flex after-tabs-part-wrapper">
            <v-tabs
                v-model="tab"
                background-color="transparent"
                slider-size="3"
                class="tab-selector-panel"
                mobile-breakpoint="0"
            >
                <v-tabs-slider color="#E43958"></v-tabs-slider>

                <v-tab
                    v-for="item in pages"
                    :key="document.id + item.FormId"
                    @click="onTabClicked(item.FormId)"
                >
                    <template v-if="item.Count < 0">
                        {{ $t(item.Name) }}
                    </template> 
                    <template v-else>
                        {{ $t(item.Name) }}
                        <span class="count" id="attachCounter">{{item.Count}}</span>
                    </template>   
                </v-tab>

            </v-tabs>

            <div
                v-if="isViewMode && document.Version && (document.RegState === 0 || document.RegState === 3 || document.RegState === 5 || document.RegState === 6)"
                class="after-tabs-part"
            >
                <v-doc-version-chip :id="document.id" :text="$t('Версии')" />
            </div>

        </div>

        <v-tabs-items
            v-model="tab"
            class="tab-content-panel"
        >
            <v-tab-item 
                v-for="item in pages"
                :key="document.id + item.FormId"
            >
                <template v-if="item.FormId == document.id">
                    <v-form class="wrapperForm" ref="form" lazy-validation>
                        <v-row dense>
                            <!--Обертка для секции-->
                            <v-col cols="12" sm="12" md="6" class="section-wrapper">

                                <!--Секция Сведения о регистрации-->
                                <v-card flat v-if="isRegistered">
                                    <v-card-text>
                                        <div class="form-box-title">{{$t("Сведения_о_регистрации")}}</div>

                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Журнал_регистрации")}}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div v-if="!document.is_new_record" class="onlyReadData">{{ document.Counter ? document.Counter.Name : '' }}</div>
                                                <v-select
                                                    v-else-if="document.is_new_record && isAccepted"
                                                    :value="document.CounterId"
                                                    @input="update({ property: 'Data.Object.Document.CounterId', value: $event })"
                                                    :items="counters"
                                                    :item-text="item => $refLocale(item, $i18n.locale)"
                                                    item-value="id"
                                                    hide-details
                                                    outlined
                                                    dense
                                                    append-icon="fas fa-chevron-down"
                                                    clearable
                                                    @click:clear="$nextTick(() => update({ property: 'Data.Object.Document.CounterId', value: '00000000-0000-0000-0000-000000000000' }))"
                                                >
                                                </v-select>
                                            </v-col>
                                        </v-row>

                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Рег._номер,_дата")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div v-if="!document.is_new_record" class="onlyReadData">{{ concatedRegistrationData  }}</div>
                                                <div v-else-if="document.is_new_record && isAccepted" class="more-inputs-in-row">
                                                    <v-text-field
                                                        :value="document.Card.RegNumber"
                                                        @input="update({ property: 'Data.Object.Document.Card.RegNumber', value: $event })"
                                                        hide-details
                                                        required
                                                        outlined
                                                        dense
                                                        :rules="requiredRule"
                                                    >
                                                    </v-text-field>

                                                    <span>{{ $t("от_время_редактирование") }}</span>
                                                    
                                                    <v-menu 
                                                        v-model="regDateMenu"
                                                        :close-on-content-click="false"
                                                        :nudge-right="40"
                                                        transition="scale-transition"
                                                        offset-y
                                                        min-width="290"
                                                    >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field
                                                                :value="regDate | formattedDate"
                                                                prepend-icon="mdi-calendar"
                                                                readonly
                                                                v-bind="attrs"
                                                                v-on="on" 
                                                                hide-details
                                                                required
                                                                outlined
                                                                dense
                                                                :rules="requiredRule"
                                                                class="datepick-input"
                                                            >
                                                            </v-text-field>
                                                        </template>

                                                        <v-date-picker
                                                            v-model="regDate"
                                                            @input="regDateMenu = false"
                                                            color="teal"
                                                            :first-day-of-week="1"
                                                        >
                                                        </v-date-picker>
                                                    </v-menu>
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <v-row no-gutters v-if="document.Counter && !isAccepted">
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Регистратор")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div class="onlyReadData">
                                                    <v-workplace-chip :id="document.Card.RegistratorWorkplaceId" :name="document.Card.RegistratorName" />
                                                </div>
                                            </v-col>
                                        </v-row>

                                    </v-card-text>
                                </v-card>

                                <!--Обертка для блока-->
                                <v-card flat>
                                    <!--Обертка для контента блока Реквизиты документа-->
                                    <v-card-text>
                                        <!--заголовок блока-->
                                        <div class="form-box-title">{{$t("Реквизиты_документа")}}</div>

                                        <!--поле Номер проекта (всегда просмотр)-->
                                        <v-row no-gutters v-if="!document.is_new_record">
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Номер_проекта")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div class="onlyReadData">{{ document.Card.DraftNumber }}</div>
                                            </v-col>
                                        </v-row>
                                        
                                        <!--поле Номенклатура-->
                                        <v-row no-gutters v-if="!isAccepted && (document.RegState != 1 || userEnterpriseId == document.EnterpriseId)">
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Номенклатура")}}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{document.Nomenclature ? `${document.Nomenclature.Code} ${document.Nomenclature.Header}` : $t("не_указано")}}
                                                </div>
                                                <v-select
                                                    v-else
                                                    :value="document.NomenclatureId != guidEmpty ? document.NomenclatureId : null"
                                                    @input="onNomenclatureInput($event)"
                                                    :items="nomenclatures"
                                                    :item-text="item => `${item.Code} ${item.Header}`"
                                                    item-value="id"
                                                    return-object
                                                    hide-details
                                                    outlined
                                                    required
                                                    dense
                                                    :rules="requiredRule"
                                                    append-icon="fas fa-chevron-down"
                                                    :menu-props="{ bottom: true, offsetY: true }"
                                                >
                                                    <template v-slot:prepend-item>
                                                        <v-list-item>
                                                            <v-list-item-content>
                                                                <v-text-field 
                                                                    :placeholder="$t('Поиск')"
                                                                    class="mb-2 autocomplete-search"
                                                                    hide-details
                                                                    dense
                                                                    clearable
                                                                    autofocus
                                                                    v-model="nomenclatureSearch"
                                                                >
                                                                </v-text-field>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </template>
                                                </v-select>
                                            </v-col>
                                        </v-row>

                                        <!--поле Вид документа-->
                                        <v-row no-gutters v-if="!isAccepted">
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{ $t("Тип_документа") }}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{document.Card.DocumentType ? document.Card.DocumentType.Value : $t("не_указано")}}
                                                </div>
                                                <v-select
                                                    v-else
                                                    :value="document.Card.DocumentType"
                                                    @input="update({ property: 'Data.Object.Document.Card.DocumentType', value: $event})"
                                                    :items="documentTypeItems"
                                                    :item-text="item => $refLocale(item, $i18n.locale)"
                                                    item-value="id"
                                                    return-object
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                    append-icon="fas fa-chevron-down"
                                                    :menu-props="{ bottom: true, offsetY: true }"
                                                >
                                                    <template v-slot:prepend-item>
                                                        <v-list-item>
                                                            <v-list-item-content>
                                                                <v-text-field 
                                                                    :placeholder="$t('Поиск')"
                                                                    class="mb-2 autocomplete-search"
                                                                    hide-details
                                                                    dense
                                                                    clearable
                                                                    autofocus
                                                                    v-model="documentTypeSearch"
                                                                >
                                                                </v-text-field>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </template>
                                                </v-select>
                                            </v-col>
                                        </v-row>

                                        <!--поле Характер вопроса-->
                                        <v-row no-gutters v-if="!isAccepted">
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Характер_вопроса")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{ document.Card.QuestCharacter ? document.Card.QuestCharacter.Value : $t("не_указано") }}
                                                </div>
                                                <v-select
                                                    v-else
                                                    :value="document.Card.QuestCharacter"
                                                    @input="update({ property: 'Data.Object.Document.Card.QuestCharacter', value: $event })"
                                                    :items="questCharacterItems"
                                                    :item-text="item => $refLocale(item, $i18n.locale)"
                                                    item-value="id"
                                                    return-object
                                                    hide-details
                                                    outlined
                                                    dense
                                                    append-icon="fas fa-chevron-down"
                                                    :menu-props="{ bottom: true, offsetY: true }"
                                                >
                                                    <template v-slot:prepend-item>
                                                        <v-list-item>
                                                            <v-list-item-content>
                                                                <v-text-field 
                                                                    :placeholder="$t('Поиск')"
                                                                    class="mb-2 autocomplete-search"
                                                                    hide-details
                                                                    dense
                                                                    clearable
                                                                    autofocus
                                                                    v-model="questCharacterSearch"
                                                                >
                                                                </v-text-field>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </template>
                                                </v-select>
                                            </v-col>
                                        </v-row>

                                        <!--поле Язык документа-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Язык_документа")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{document.Card.Languages ? documentLanguages.map((x) => x.Value).join(', ') : $t("не_указано")}}
                                                </div>
                                                <v-autocomplete
                                                    v-else
                                                    v-model="documentLanguages"
                                                    :items="GetReference(1000)"
                                                    :item-text="item => $refLocale(item, $i18n.locale)"
                                                    item-value="id"
                                                    multiple
                                                    return-object
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="multipleRule"
                                                    append-icon="fas fa-chevron-down"
                                                >
                                                </v-autocomplete>
                                            </v-col>
                                        </v-row>

                                        <!--поле Тип носителя-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Тип_носителя")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div v-if="isViewMode || isAccepted" class="onlyReadData">
                                                    {{document.Card.CarrierType ? document.Card.CarrierType.Value : $t("не_указано")}}
                                                </div>
                                                <v-autocomplete
                                                    v-else
                                                    :value="document.Card.CarrierType"
                                                    @input="update({ property: 'Data.Object.Document.Card.CarrierType', value: $event})"
                                                    :items="GetReference(1024)"
                                                    :item-text="item => $refLocale(item, $i18n.locale)"
                                                    item-value="id"
                                                    return-object
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                    append-icon="fas fa-chevron-down"
                                                >
                                                </v-autocomplete>
                                            </v-col>
                                        </v-row>
                                        
                                        <!--поле Количество ЛПЭ-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{ $t("Количество_листов/приложений") }}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{`${document.Card.ListCount}/${document.Card.AttachCount}`}}
                                                </div>
                                                <div class="more-inputs-in-row" v-else>
                                                    <v-text-field
                                                        :value="document.Card.ListCount"
                                                        @input="update({ property: 'Data.Object.Document.Card.ListCount', value: $event})"
                                                        hide-details
                                                        required
                                                        outlined
                                                        dense
                                                        type="number"
                                                        :rules="integerNotNull"
                                                        class="cust-inputnumber"
                                                        min="0"
                                                    >
                                                    </v-text-field>
                                                    <span>/</span>
                                                    <v-text-field
                                                        :value="document.Card.AttachCount"
                                                        @input="update({ property: 'Data.Object.Document.Card.AttachCount', value: $event})"
                                                        hide-details
                                                        required
                                                        outlined
                                                        dense
                                                        type="number"
                                                        :rules="integerRule.concat(requiredRule)"
                                                        class="cust-inputnumber"
                                                        min="0"
                                                    >
                                                    </v-text-field>
                                                </div>
                                            </v-col>
                                        </v-row>

                                    </v-card-text>
                                </v-card>

                            </v-col>
                            
                            <v-col cols="12" sm="12" md="6" class="section-wrapper">

                                <v-card flat>
                                    <v-card-text>
                                        <div class="form-box-title">{{ $t("Сведения_об_акте") }}</div>

                                        <!--поле Тип акта-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Тип_НПА")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{document.NPAType>=0 ? $t(GetNPATypes[document.NPAType].Value) : $t("не_указано")}}
                                                </div>
                                                <v-autocomplete
                                                    v-else
                                                    :value="document.NPAType"
                                                    @input="update({ property: 'Data.Object.Document.NPAType', value: $event.id})"
                                                    :items="GetNPATypes"
                                                    :item-text="item => $t(item.Value)"
                                                    item-value="id"
                                                    return-object
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                    append-icon="fas fa-chevron-down"
                                                >
                                                </v-autocomplete>
                                            </v-col>
                                        </v-row>

                                        <!--Орган, принявший акт-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Орган_принявший_акт")}}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div class="icon-click-row-group icrg-align-center">
                                                    <div v-if="!isViewMode" @click="onEnterpriseAcceptingActSelect">
                                                        <v-icon small v-tooltip.left-center="selectEnterpriseAcceptingActTooltip">
                                                            fas fa-edit
                                                        </v-icon>
                                                    </div>
                                                    <div class="onlyReadData">
                                                        <v-enterprise-chip v-if="document.Card.EnterpriseAcceptingActName" 
                                                            :id="document.Card.EnterpriseAcceptingActId" 
                                                            :name="locale=='ru' ? document.Card.EnterpriseAcceptingActName['ru-RU'] : document.Card.EnterpriseAcceptingActName['kk-KZ']"
                                                            :canDelete="!isViewMode"
                                                            :delFunc="onDeleteEnterpriseAcceptingAct" 
                                                        />
                                                        <div v-else class="chipAreaNoData d-flex align-center pl-1">
                                                            <v-select-members-chip
                                                                v-if="!isViewMode"
                                                                target-type="Member"
                                                                @on-select="onEnterpriseAcceptingActSelectByChip"
                                                                :items-params="enterpriseAcceptingActSelectParam"
                                                                :required="true"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <!--Подписывающий акт-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Подписывающий_акт")}}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div class="icon-click-row-group icrg-align-center">
                                                    <div v-if="!isViewMode && document.Card.EnterpriseAcceptingActName" @click="onEmployeeSigningActSelect">
                                                        <v-icon small v-tooltip.left-center="selectEmployeeSigningActTooltip">
                                                            fas fa-edit
                                                        </v-icon>
                                                    </div>
                                                    <div class="onlyReadData" >
                                                        <v-workplace-chip v-if="document.Card.NameOfEmployeeSigningAct"
                                                            :id="document.Card.EmployeeSigningActId" 
                                                            :name="document.Card.NameOfEmployeeSigningAct"
                                                            :canDelete="!isViewMode"
                                                            :delFunc="onDeleteEmployeeSigningAct"
                                                        />
                                                        <div v-else class="chipAreaNoData d-flex align-center pl-1">
                                                            <v-select-members-chip
                                                                v-if="!isViewMode && document.Card.EnterpriseAcceptingActName"
                                                                target-type="Member"
                                                                @on-select="onEmployeeSigningActByChip"
                                                                :items-params="employeeSignigActSelectParam"
                                                                :required="true"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <!--Орган разработчик НПА-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Орган-разработчик_НПА")}}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div class="icon-click-row-group icrg-align-center">
                                                    <div v-if="!isViewMode" @click="onEnterpriseDevelopingActSelect">
                                                        <v-icon small v-tooltip.left-center="selectEnterpriseDevelopingActTooltip">
                                                            fas fa-edit
                                                        </v-icon>
                                                    </div>
                                                    <div class="onlyReadData">
                                                        <v-enterprise-chip v-if="document.Card.EnterpriseDeveloperActName" 
                                                            :id="document.EnterpriseId" 
                                                            :name="locale=='ru' ? document.Card.EnterpriseDeveloperActName['ru-RU'] : document.Card.EnterpriseDeveloperActName['kk-KZ']"
                                                            :canDelete="!isViewMode"
                                                            :delFunc="onDeleteEnterpriseDevelopingAct" 
                                                        />
                                                        <div v-else class="chipAreaNoData d-flex align-center pl-1">
                                                            <v-select-members-chip
                                                                v-if="!isViewMode"
                                                                target-type="Member"
                                                                @on-select="onEnterpriseDevelopingActSelectByChip"
                                                                :items-params="enterpriseAcceptingActSelectParam"
                                                                :required="true"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <!--поле Исполнитель-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{ $t("Исполнитель") }}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div class="icon-click-row-group icrg-align-center">                                                    
                                                    <div v-if="!isViewMode" @click="onExecuterSelect">
                                                        <v-icon small v-tooltip.left-center="selectExecuterTooltip">
                                                            fas fa-edit
                                                        </v-icon>
                                                    </div>
                                                    <div class="onlyReadData">
                                                        <v-workplace-chip v-if="document.Card.ExecuterName"
                                                            :id="document.Card.ExecuterWorkplaceId"
                                                            :name="document.Card.ExecuterName"
                                                            :canDelete="!isViewMode"
                                                            :delFunc="onDeleteExecuter"
                                                        />
                                                        <div v-else class="chipAreaNoData d-flex align-center pl-1">
                                                            <v-select-members-chip
                                                                v-if="!isViewMode"
                                                                target-type="Member"
                                                                @on-select="onExecuterSelectByChip"
                                                                :items-params="executerSelectParam"
                                                                :required="true"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <!--поле Телефон исполнителя-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Телефон_исполнителя")}}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{document.Card.Phone ? document.Card.Phone : $t("не_указано")}}
                                                </div>
                                                <v-text-field
                                                    v-else
                                                    :value="document.Card.Phone"
                                                    @input="update({ property: 'Data.Object.Document.Card.Phone', value: $event})"
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                >
                                                </v-text-field>
                                            </v-col>
                                        </v-row>

                                        <!--поле Срок действия НПА-->
                                        <v-row v-if="!(document.TerminatedBy || document.ReasonCancel)" no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Срок_действия")}}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{ document.Srok ? formatDate(document.Srok) : $t("Бессрочный") }}
                                                </div>
                                                <v-menu
                                                    v-else
                                                    v-model="srokMenu"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290"
                                                >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field
                                                            :value="srok | formattedDate"
                                                            prepend-icon="mdi-calendar"
                                                            readonly
                                                            v-bind="attrs"
                                                            v-on="on" 
                                                            hide-details
                                                            outlined
                                                            dense
                                                            class="datepick-input"
                                                        >
                                                        </v-text-field>
                                                    </template>

                                                    <v-date-picker
                                                        v-model="srok"
                                                        @input="srokMenu = false"
                                                        color="teal"
                                                        :first-day-of-week="1"
                                                    >
                                                    </v-date-picker>
                                                </v-menu>
                                            </v-col>
                                        </v-row>

                                        <v-row no-gutters v-if="document.Card.SignerName">
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Подписант")}}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div class="onlyReadData">
                                                    <v-workplace-chip :id="document.Card.SignerWorkplaceId" :name="document.Card.SignerName" />
                                                </div>
                                            </v-col>
                                        </v-row>

                                    </v-card-text>
                                </v-card>

                                <v-card flat v-if="isViewMode">
                                    <v-card-text>
                                        <div class="form-box-title">{{ $t("Кем_создано") }}</div>

                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Сотрудник")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div class="onlyReadData">
                                                    <v-employee-chip :id="document.AuthorId" :name="document.AuthorName" />
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Дата_создания")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div class="onlyReadData">{{ formatDate(document.CreateDate) }}</div>
                                            </v-col>
                                        </v-row>
                                    
                                    </v-card-text>
                                </v-card>
                            </v-col>

                            <v-col cols="12" sm="12" md="12" class="section-wrapper">
                                <v-card flat v-if="isViewMode && (document.TerminatedBy || document.TerminationList || document.ChangedByList || document.ChangeList)">
                                    <v-card-text>
                                        <div class="form-box-title">{{ $t("Связанные_НПА") }}</div>

                                        <v-row v-if="document.ChangedByList" class="full-width-row" no-gutters>
                                            <v-col cols="12" sm="12" md="2">
                                                <label class="f-label">{{ $t("Изменен_документами") }}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="10">
                                                <div class="onlyReadData flex-wrap">
                                                    <v-document-link 
                                                        v-for="(id, i) in document.ChangedByList" 
                                                        :key="i" 
                                                        :isViewMode="true" 
                                                        :id="id" 
                                                        :type="'Documents.NPA.Document'" 
                                                        :text="document.ChangedByNameList[i]" 
                                                        :common="true"
                                                        :canDelete="allowRemoveLink"
                                                        :typeNPALink="0"
                                                        :delFunc="DeleteLink"
                                                        class="mr-2" 
                                                    />
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <v-row v-if="document.ChangeList" class="full-width-row" no-gutters>
                                            <v-col cols="12" sm="12" md="2">
                                                <label class="f-label">{{ $t("Изменяет_документы") }}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="10">
                                                <div class="onlyReadData flex-wrap">
                                                    <v-document-link 
                                                        v-for="(id, i) in document.ChangeList" 
                                                        :key="i" 
                                                        :isViewMode="true" 
                                                        :id="id" 
                                                        :type="'Documents.NPA.Document'" 
                                                        :text="document.ChangeNameList[i]" 
                                                        :common="true"
                                                        class="mr-2"
                                                        :canDelete="true"
                                                    />
                                                </div>
                                            </v-col>                                            
                                        </v-row>

                                        <v-row v-if="document.TerminatedBy" class="full-width-row" no-gutters>
                                            <v-col cols="12" sm="12" md="2">
                                                <label class="f-label">{{ $t("Отменен_документом") }}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="10">
                                                <div class="onlyReadData flex-wrap">
                                                    <v-document-link 
                                                        :isViewMode="true" 
                                                        :id="document.TerminatedBy" 
                                                        :type="'Documents.NPA.Document'" 
                                                        :text="document.TerminatedByName" 
                                                        :common="true"
                                                        :canDelete="allowRemoveLink"
                                                        :typeNPALink="1"
                                                        :delFunc="DeleteLink" 
                                                    />
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <v-row v-if="document.TerminationList" class="full-width-row" no-gutters>
                                            <v-col cols="12" sm="12" md="2">
                                                <label class="f-label">{{ $t("Отменяет_документы") }}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="10">
                                                <div class="onlyReadData flex-wrap">
                                                    <v-document-link 
                                                        v-for="(id, i) in document.TerminationList" 
                                                        :key="i" 
                                                        :isViewMode="true" 
                                                        :id="id" 
                                                        :type="'Documents.NPA.Document'" 
                                                        :text="document.TerminationNameList[i]" 
                                                        :common="true"
                                                        class="mr-2"
                                                    />
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <v-row v-if="document.TerminatedBy || document.ReasonCancel" class="full-width-row" no-gutters>
                                            <v-col cols="12" sm="12" md="2">
                                                <label class="f-label">{{ $t("Отменен_с") }}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="10">
                                                <div class="onlyReadData">
                                                    {{ srok | formattedDate}}
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <v-row v-if="document.ReasonCancel" class="full-width-row" no-gutters>
                                            <v-col cols="12" sm="12" md="2">
                                                <label class="f-label">{{$t("Причина_отмены")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="10">
                                                <div class="onlyReadData">
                                                    {{ document.ReasonCancel }}    
                                                </div>
                                                <!--<v-textarea 
                                                    :value="document.Theme"
                                                    @input="update({ property: 'Data.Object.Document.Theme', value: $event})"
                                                    rows="3"
                                                    no-resize
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                >
                                                </v-textarea>-->
                                            </v-col>
                                        </v-row>

                                    </v-card-text>
                                </v-card>
                            </v-col>

                            <v-col cols="12" sm="12" md="12" class="section-wrapper">

                                <v-card flat>
                                    <v-card-text>
                                        <div class="form-box-title">{{$t("Краткое_содержание")}}</div>

                                        <v-row class="full-width-row" no-gutters>
                                            <v-col cols="12" sm="12" md="2">
                                                <label class="f-label">{{$t("Краткое_содержание")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="10">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{ document.Theme }}
                                                </div>
                                                <v-textarea v-else
                                                    :value="document.Theme"
                                                    @input="update({ property: 'Data.Object.Document.Theme', value: $event})"
                                                    rows="3"
                                                    no-resize
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                >
                                                </v-textarea>
                                            </v-col>
                                        </v-row>

                                    </v-card-text>
                                </v-card>
                                <v-card flat>
                                    <v-card-text>
                                        <div class="form-box-title">{{ $t("Доступ_к_документу") }}</div>

                                        <v-row class="full-width-row" no-gutters>
                                            <v-col cols="12" sm="12" md="2">
                                                <label class="f-label">{{ $t("Доступ_к_документу") }}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="10">
                                                <div class="icon-click-row-group">
                                                    <div v-if="!isViewMode" @click="onRecipientsSelect">
                                                        <v-icon small v-tooltip.left-center="selectRecipientsTooltip">
                                                            fas fa-edit
                                                        </v-icon>
                                                    </div>
                                                    <div v-if="document.Card.Recipients.length == 0 && !isViewMode" class="chipAreaNoData d-flex align-center pl-1">
                                                        <v-select-members-chip
                                                            target-type="Member"
                                                            @on-select="onRecipientsSelectByChip"
                                                            :items-params="enterpriseAcceptingActSelectParam"
                                                            :required="true"
                                                        />
                                                    </div>
                                                    <div class="onlyReadData more-per-lab-wrap" v-else>
                                                        <template v-for="recipient in document.Card.Recipients">
                                                            <v-enterprise-chip
                                                                :id="recipient.Id"
                                                                :key="recipient.Id"
                                                                :name="recipient.Name"
                                                                :canDelete="!isViewMode"
                                                                :delFunc="onDeleteRecipient"
                                                            />
                                                        </template>
                                                        <v-select-members-chip
                                                            v-if="!isViewMode"
                                                            target-type="Member"
                                                            @on-select="onRecipientsSelectByChip"
                                                            :items-params="enterpriseAcceptingActSelectParam"
                                                        />
                                                    </div>
                                                </div>
                                            </v-col>
                                        </v-row>

                                    </v-card-text>
                                </v-card>
                            </v-col>

                        </v-row>
                    </v-form>
                </template>
                
                <template v-else>
                    <component                         
                        :is="$mapComponent(item.FormId)" 
                        :ref="item.FormId" 
                        :id="document.id"
                    />
                </template>

            </v-tab-item>

        </v-tabs-items>

        <CreateCustomRecipientDlg v-if="!isViewMode && isBypassing" ref="CreateCustomRecipientDlgRef" />
        <ChangeStatusNpaDlg ref="ChangeStatusNpaDlgRef" />

    </div>
</template>

<script>
import i18n from '@/i18n';
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';

import { httpAPI } from "@/api/httpAPI";
import sys from '@/services/system';
import Toolbar from '@/components/documents/Toolbar.vue';
import DocumentPanel from '@/components/documents/DocumentPanel.vue';
import CreateCustomRecipientDlg from '@/components/documents/dialogs/CreateCustomRecipientDlg.vue';
import ChangeStatusNpaDlg from '@/components/npa/dialogs/ChangeStatusNpaDlg.vue';

export default {
    name: "NPADocumentCard",
    components: {
        Toolbar,
        DocumentPanel,
        CreateCustomRecipientDlg,
        ChangeStatusNpaDlg
    },
    filters: {
        formattedDate: function (value) {
            var formatedDate = sys.dateFormat(value, 'DD.MM.YYYY');
            return formatedDate ?? "";
        }
    },
    asyncComputed: {
        documentTypeItems: {
            async get () {
                let items = Array.from(await this.$store.dispatch('documents/references/getReference', { id: 1001 }));

                if (this.documentTypeSearch)
                    return items.filter(i => sys.checkSearch(i.Value, this.documentTypeSearch) || i.id == this.document?.Card?.DocumentType?.id);
                else
                    return items;
            },
            default: [],
            watch: ['documentTypeSearch']
        },
        questCharacterItems: {
            async get () {
                let items = Array.from(await this.$store.dispatch('documents/references/getReference', { id: 1003 }));

                if (this.questCharacterSearch)
                    return items.filter(i => sys.checkSearch(i.Value, this.questCharacterSearch) || i.id == this.document?.Card?.QuestCharacter?.id);
                else
                    return items;
            },
            default: [],
            watch: ['questCharacterSearch']
        },
        nomenclatures : {
            async get() {
                if (this.nomenclatureSearch) {                
                    return (await this.$store.dispatch('documents/references/getNomenclatures', { forDepartment: false }))
                        .map(x => ({ id: x[0], Code: x[1], Header: x[2] }))
                        .filter(i => sys.checkSearch(`${i.Code} ${i.Header}`, this.nomenclatureSearch) || i.id == this.nomenclature?.id);
                }
                else
                    return (await this.$store.dispatch('documents/references/getNomenclatures', { forDepartment: false }))
                        .map(x => ({ id: x[0], Code: x[1], Header: x[2] }));
            },
            default: [],
            watch: ['nomenclatureSearch']
        },
        counters: {
            async get () {
                let response = await httpAPI({
                    url: `/api/references/counters/17`,
                    method: 'GET'
                });

                return this.$_(response.data.Payload.Data
                    .map( x => ({ id: x[0], Value: `${x[2]} (${x[1]})` })))
                    .orderBy(['Value'], ['asc'])
                    .value();
            },
            default: []
        }
    },
    computed: {
        ...mapGetters('global/auth', { userInfo: 'getUserInfo', userEnterpriseId: 'getUserEnterpriseId' }),
        ...mapGetters('documents/references', ['GetReference', 'GetNPATypes']),
        ...mapGetters('global/actionsource', { dataSource: 'getDataSource', dataSourceType: 'getDataSourceType', isCommon: 'isDataSourceCommon' }),
        ...mapGetters({ 
            requiredRule: 'getRequiredRule',
            multipleRule: 'getMultipleRule',
            integerRule: 'getIntegerRule',
            integerNotNull: 'getIntegerNotNullRule'
        }),
        documentLanguages: {
            get: function() {
                return this.document.Card.Languages?.data_list ?? [];
            },
            set: function(value) {
                if (this.document.Card.Languages != null)
                    this.updateSource({ property: 'Data.Object.Document.Card.Languages.data_list', value });
                else
                    this.updateSource({ property: 'Data.Object.Document.Card.Languages', value: { data_list: value } });
            }
        },
        isViewMode() {
            return this.dataSource?.Data.FormId == "0201131";
        },
        isAccepted() {
            return this.document.IsAccepted;
        },
        document() {
            return this.dataSource?.Data.Object.Document;
        },
        pages() {
            let pages = 
            [
                { Count: -1, FormId: this.document?.id, Name: "Карточка" }
            ];
            
            //ЭКБ НПА
            if (this.document?.EECBActMetadata != null)
                pages.push({ Count: -1, FormId: "GovermentRegistration", Name: i18n.t("Государственная_регистрация") });

            pages = pages.concat(this.dataSource?.Data?.Object?.Pages ?? []);

            return pages;
        },
        isRegistered() {
            return (this.document.RegState == 1 || this.document.RegState == 4) || this.isAccepted; 
        },
        concatedRegistrationData() {
            let result = i18n.t("Не_указано");

            if (this.document.Card.RegNumber?.length)
                result = `№ ${this.document.Card.RegNumber}`;

            if (this.document.Card.RegDate)
                result += ` ${this.$t("от_время")} ${this.formatDate(this.document.Card.RegDate)} г.`;

            return result;
        },
        isBypassing() {
            return this.document?.NotDraft === true;
        },
        selectExecuterTooltip(){
            return i18n.t("Выбрать_исполнителя");
        },
        selectNomenclatureTooltip(){
            return i18n.t("Выбрать_номенклатуру");
        },
        selectEnterpriseAcceptingActTooltip(){
            return i18n.t("Выбрать_организацию_в_которой_будет_подписываться_проект_акта");
        },
        selectEnterpriseDevelopingActTooltip(){
            return i18n.t("Выбрать_организацию_разработавшую_акт");
        },
        selectEmployeeSigningActTooltip(){
            return i18n.t("Выбрать_сотрудника_организации_которому_проект_будет_уходить_на_подпись");
        },
        selectRecipientsTooltip(){
            return i18n.t("Выбрать_организации_у_которых_будет_доступ_к_документу");
        },
        guidEmpty() {
            return sys.guidEmpty();
        },
        locale() {
            return i18n.locale;
        },
        executerSelectParam() {
            let ret =  { 
                title: i18n.t("Выбор_исполнителя"),
                includeInner: true,
                ignoreCache: true,
                multiple: false,
                selected: [ this.document.Card.ExecuterWorkplaceId ]
            }

            if (this.document.EnterpriseId != this.userInfo.EnterpriseId){
                ret.entArr = [this.document.EnterpriseId];
                ret.includeOuter = true;
                //ret.ReplaseCurrentEnterpriseName = this.locale=='ru' ? this.document.Card.EnterpriseDeveloperActName['ru-RU'] : this.document.Card.EnterpriseDeveloperActName['kk-KZ'];
            }
            return ret;
        },
        employeeSignigActSelectParam(){
            let ret =  { 
                title: i18n.t("Выбор_подписанта"),
                includeInner: true,
                NPASignersAct: true,
                onlySigners: true,
                multiple: false,
                selected: [ this.document.Card.EmployeeSigningActId ]
            }
            if (this.document.Card.EnterpriseAcceptingActId != this.$store.getters['global/auth/getUserEnterpriseId'])
                ret.EnterpriseAdjastmentName = this.document.Card.EnterpriseAcceptingActName[this.locale == 'kk' ? 'kk-KZ' : 'ru-RU'];
            return ret;
        },
        enterpriseAcceptingActSelectParam() {
            return {
                only_work_enterprises: true,
                selected: this.document?.Card?.Recipients?.map(x=> x.Id) ?? []
            }
        },
        srok: {
            get: function() {
                if (this.document.Srok)
                    return this.$moment(this.document.Srok).format('YYYY-MM-DD');
                
                return this.document.Srok;
            },
            set: function(newValue) {
                this.updateSource({ property: 'Data.Object.Document.Srok', value: `/Date(${Date.parse(newValue)})/` });
            }
        },
        regDate: {
            get: function() {
                if (this.document.Card.RegDate)
                    return this.$moment(this.document.Card.RegDate).format('YYYY-MM-DD');
                
                return this.document.Card.RegDate;
            },
            set: function(newValue) {
                this.updateSource({ property: 'Data.Object.Document.Card.RegDate', value: `/Date(${Date.parse(newValue)})/` });
            }
        },
        allowRemoveLink() {
            return !!this.dataSource.Data.Menu.find(m => m.Action === 'ChangeStatusNPA');
        }
    },
    data() {
        return {
            tab: null,
            questCharacterSearch: "",
            documentTypeSearch: "",
            nomenclatureSearch: "",

            srokMenu: false,
            regDateMenu: false
        }
    },
    methods: {
        ...mapActions(['setOverlayVisible']),      
        ...mapActions('global/actionsource', { updateSource: 'updateDataSource' }),
        onTabClicked (formId) {
            if (this.$refs[formId])
                this.$refs[formId][0]?.update();
        },
        async onToolbarClick (event, button) {
            let localActionType = typeof this[button.Action];
            
            if (localActionType === 'function') {
                this[button.Action](event, button);
                return;
            }

            let actions = Reflect.ownKeys(this.$store._actions).filter(i => i.includes('global/actionsource/')).map(i => {return i.split('/')[2]})

            if (!actions.includes(button.Action)) {
                this.$notify.alert(`Действие_${button.Action}_не_реализовано.`);
                return;
            }

            if (button.Action == 'Save' || button.Action == 'SaveAndClose') {
                let validate_result = this.$refs.form[0].validate();

                if (validate_result && this.document.Card.EnterpriseAcceptingActName && this.document.Card.EmployeeSigningActId) {
                    await this.$store.dispatch(`global/actionsource/${button.Action}`, {event, button});        
                }
                else {
                    this.$notify.alert(i18n.t("Не_заполнены_обязательные_поля"));
                }
                return;
            }

            await this.$store.dispatch(`global/actionsource/${button.Action}`, {event, button});
        },
        async ChangeStatusNPA() {
            let params = await this.$refs.ChangeStatusNpaDlgRef.open();

            if (params.isCancelled === true) return;
            
            this.setOverlayVisible({ visible: true });

            let content = {
                npaId: this.document.id,
                typeChange: params.type,
                sourceNPAId: params.documentId,
                srok: params.date,
                reasonCancel: params.reason
            }

            let response = await httpAPI({
                url: `api/npa/change-status`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'isCommon': this.isCommon },
                data: { Content : JSON.stringify(content) }
            });

            if (response) {
                this.$store.commit('global/actionsource/SET_DATASOURCE', { datasource: response.data.Payload });
                this.$store.commit('documents/toolbar/SET_MENU', { menu: response.data.Payload.Data.Menu });
                this.$notify.success(this.$t('Действие_успешно_выполнено'));
            }

            this.setOverlayVisible({ visible: false });
        },
        formatDate (source) {
            return this.$moment(source).format('DD.MM.YYYY');
        },
        async onEnterpriseAcceptingActSelect (){
            try {
                let enterprise = await this.$store.dispatch('global/dialogs/selectEnterprise/open', {multyselect: false, selected: [this.document.Card.EnterpriseAcceptingActId]});    
                this.setEnterpriseAcceptingAct(enterprise);
            }
            catch (ex) {
                console.log(ex);
            }
        },
        async onEnterpriseAcceptingActSelectByChip(e) {
            this.setEnterpriseAcceptingAct(e.value);
        },
        async onDeleteEnterpriseAcceptingAct() {
            this.setEnterpriseAcceptingAct(null);
        },
        async setEnterpriseAcceptingAct(enterprise) {
            if (enterprise){
                if (this.document.Card.EnterpriseAcceptingActId != enterprise.id){
                    let uniName = {};
                    uniName['ru-RU'] = enterprise.name;
                    uniName['kk-KZ'] = enterprise.name;
                    this.updateSource({ property: 'Data.Object.Document.Card.EnterpriseAcceptingActName',  value: uniName });
                    this.updateSource({ property: 'Data.Object.Document.Card.EnterpriseAcceptingActId',  value: enterprise.id});
                    this.onDeleteEmployeeSigningAct();
                }
            }
            else{
                this.updateSource({ property: 'Data.Object.Document.Card.EnterpriseAcceptingActName',  value: null });
                this.updateSource({ property: 'Data.Object.Document.Card.EnterpriseAcceptingActId',  value: null});
                this.onDeleteEmployeeSigningAct();
            }
        },
        async onEnterpriseDevelopingActSelect() {
            try {
                let enterprise = await this.$store.dispatch('global/dialogs/selectEnterprise/open', {multyselect: false, selected: [this.document.EnterpriseId]});    
                this.setEnterpriseDevelopingAct(enterprise);
            }
            catch (ex) {
                console.log(ex);
            }
        },
        async onEnterpriseDevelopingActSelectByChip(e){
            this.setEnterpriseDevelopingAct(e.value);
        },
        async onDeleteEnterpriseDevelopingAct(){
            this.setEnterpriseDevelopingAct(null);
        },
        async setEnterpriseDevelopingAct(enterprise){
            if (enterprise){
                if (this.document.EnterpriseId != enterprise.id){
                    let uniName = {};
                    uniName['ru-RU'] = enterprise.name;
                    uniName['kk-KZ'] = enterprise.name;
                    this.updateSource({ property: 'Data.Object.Document.Card.EnterpriseDeveloperActName',  value: uniName });
                    this.updateSource({ property: 'Data.Object.Document.EnterpriseId',  value: enterprise.id});
                    this.onDeleteExecuter();
                }
            }
            else{
                this.updateSource({ property: 'Data.Object.Document.Card.EnterpriseDeveloperActName',  value: null });
                this.updateSource({ property: 'Data.Object.Document.EnterpriseId',  value: null});
                this.onDeleteExecuter();
            }
        },
        async onEmployeeSigningActSelect (){
            try {
                let selectMemberParams = this.employeeSignigActSelectParam;
                let employee = await this.$store.dispatch('global/dialogs/selectMembersNew/open', selectMemberParams);                
                this.setEmployeeSigningAct(employee);
            }
            catch (ex) {
                console.log(ex);
            }
        },
        async onEmployeeSigningActByChip(e){
            this.setEmployeeSigningAct(e.value);
        },
        async onDeleteEmployeeSigningAct(){
            this.setEmployeeSigningAct(null);
        },
        async setEmployeeSigningAct(value){
            this.updateSource({ property: 'Data.Object.Document.Card.NameOfEmployeeSigningAct',  value: value?.name});
            this.updateSource({ property: 'Data.Object.Document.Card.EmployeeSigningActId',  value: value?.workplaceId});
        },
        async onExecuterSelect() {
            try {
                let selectMemberParams = this.executerSelectParam;
                let executer = await this.$store.dispatch('global/dialogs/selectMembersNew/open', selectMemberParams);    
                this.setExecuter(executer);
            }
            catch (ex) {
                console.log(ex);
            }
        },
        async onExecuterSelectByChip(e){
            this.setExecuter(e.value);
        },
        async onDeleteExecuter(){
            this.setExecuter(null);
        },
        async setExecuter(value){
            this.updateSource({ property: 'Data.Object.Document.Card.ExecuterName',  value: value?.name });
            this.updateSource({ property: 'Data.Object.Document.Card.ExecuterWorkplaceId',  value: value?.workplaceId });
            this.updateSource({ property: 'Data.Object.Document.Card.ExecuterId',  value: value?.employeeId });

            let phone = value?.contacts?.find(contact => { return contact.type === "phone"; }) ?? null;
            this.updateSource({ property: 'Data.Object.Document.Card.Phone', value: phone?.value ?? null });
        },
        async onRecipientsSelect () {
            try {
                let selected = this.document?.Card?.Recipients?.map(x=> x.Id) ?? [];
                let dlgResult = await this.$store.dispatch('global/dialogs/selectEnterprise/open', { multyselect: true, selected });
                this.updateSource({ property: 'Data.Object.Document.Card.Recipients', value: dlgResult.map(x => ({ Id: x.id, IsEmployee: false, Name: x.name }))});
            }
            catch (ex) {
                console.log(ex);
            }
        },
        async onRecipientsSelectByChip(e){
            if (e?.value){
                let value = [ ...this.document.Card.Recipients, { Id: e.value.id, IsEmployee: false, Name: e.value.name }];
                this.updateSource({ property: 'Data.Object.Document.Card.Recipients', value });
            }
        },
        async onDeleteRecipient(id){
            let tmp = Array.from(this.document.Card.Recipients);
            let itemToRemove = tmp.find(x=>x.Id == id);
            if (itemToRemove) {
                let index = tmp.indexOf(itemToRemove);
                if (index > -1) {
                    tmp.splice(index, 1);
                    this.updateSource({ property: 'Data.Object.Document.Card.Recipients', value: tmp });
                }
            }
        },
        async onNomenclatureSelect (){
            try {
                let selected = await this.$store.dispatch('global/dialogs/selectNomenclature/open', null);
                this.updateSource({ property: 'Data.Object.Document.Nomenclature', value: { Code: selected[1], Header: selected[2] } });
                this.updateSource({ property: 'Data.Object.Document.NomenclatureId', value: selected[0] });
            }
            catch (ex) {
                console.log(ex.message);
            }
        },
        onNomenclatureInput(event) {
            this.updateSource({ property: 'Data.Object.Document.Nomenclature', value: { Code: event.Code, Header: event.Header } });
            this.updateSource({ property: 'Data.Object.Document.NomenclatureId', value: event.id });
        },
        update: _.debounce(function (object) {
            this.updateSource(object);
        }, 250),
        async DeleteLink(id, type){
            this.$notify.confirm(
                this.$t('Вы_действительно_хотите_удалить_связь_документа'),
                async () =>
                {
                    this.setOverlayVisible({ visible: true });

                    let content = {
                        npaId: this.document.id,
                        typeChange: type,
                        sourceNPAId: id
                    }

                    let response = await httpAPI({
                        url: `api/npa/remove-change-status`,
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'isCommon': this.isCommon },
                        data: { Content : JSON.stringify(content) }
                    });

                    if (response) {
                        this.$store.commit('global/actionsource/SET_DATASOURCE', { datasource: response.data.Payload });
                        this.$store.commit('documents/toolbar/SET_MENU', { menu: response.data.Payload.Data.Menu });
                        this.$notify.success(this.$t('Действие_успешно_выполнено'));
                    }

                    this.setOverlayVisible({ visible: false });
                }
            );
        }
    },
    async created() {        
        (async() => {
            while(typeof this.$refs.form === 'undefined')
                await new Promise(resolve => setTimeout(resolve, 100));

            this.$refs?.form?.[0]?.validate();
        })();
    },
    updated() {
        if (this.dataSource !== null) {
            this.$refs?.form?.[0]?.validate();
        }  
    },
    mounted() {        
        this.$eventBus.$on('set-active-tab', async ({ FormId }) => {
            let page = this.pages.find(x => x.FormId === FormId);

            if (page) {
                let targetIndex = this.pages.indexOf(page);

                if (this.tab != targetIndex)
                    this.tab = targetIndex;
                else
                    this.$eventBus.$emit('update-active-tab');
            }
        });
    },
    beforeDestroy() {
        this.$eventBus.$off('set-active-tab');
    }
}
</script>